import ITag from '../../../components/ITag'
import {toast} from "react-toastify";
import {useRef} from "react";
import { UploadShim, uploadProxy } from '../../../UploadShim';
import { useAuth } from '../../../lib/auth';
import { sessionStorageGet } from '../../../lib/window-shim';
import { uploadFile } from '../../../lib/api';

/**
 * SecAvatar component.
 *
 * Displays user avatar/profile picture with optional edit button.
 * Features:
 * - Avatar image with error fallback
 * - Upload functionality (if editAllowed)
 * - Click handler to trigger file upload
 * - Sends image via targetProxy to backend
 *
 * @param {Object} props - Component props
 * @param {string|number} props.img - User ID for avatar URL construction
 * @param {Object} props.pi - Profile info (unused)
 * @param {Function} props.imgErr - Error handler for image load failures
 * @param {boolean} props.editAllowed - Whether to show edit button
 * @param {Function} props.sur - State update refresh trigger
 * @returns {React.ReactElement} Avatar component with edit overlay
 */
function SecAvatar({ img, pi, imgErr, editAllowed, sur }){
    if (!img) return null; // Prevent undefined-ID image loop
    let cacheImg = "https://cdn.stealthisnft.xyz/u/"+img+"/profile/avatar.jpg";
    let fileRef = useRef(null);

    const upload = (itype) => {
        fileRef.current.click();
    }//helki
    const doUpload = async (e) => {

        let file = e.target.files[0];

        let fdd = {};
        fdd.descr = "Avatar Pic"; fdd.filen = file.name; fdd.cid = 0; fdd.colln = "Avatar";
        const rawToken = sessionStorageGet("token");
        const parsedToken = rawToken ? JSON.parse(rawToken) : null;
        fdd.wall = parsedToken?.account?.id;
        fdd._token = parsedToken;
        fdd.nft_contract = "";
        fdd.nft_currentOwner = "0x00";
        fdd.isCached = false
        fdd.ppic = true;
        if(fdd._token?.account?.is_admin) { fdd.wall = img}
        // handle validations
        //toast("Upload");
        let formData = new FormData();
        formData.append("json", JSON.stringify(fdd));
        formData.append("blob", e.target.files[0]);
        await uploadFile(formData);
        sur(Math.random());

    }

  return(
      <div className="col-auto">
        <div className="avatar avatar-xl position-relative">
          <img id="avatar_p" onError={(e)=>imgErr(e)} src={cacheImg} alt="..." className="w-100 border-radius-lg shadow-sm" />
            {editAllowed ? <button onClick={() => upload("avatar")} className="btn btn-sm btn-icon-only bg-gradient-light rounded-circle position-absolute bottom-0 end-0 m-1 profile-avatar-edit-btn">
            <ITag ClassName="fa fa-pen top-0" data-bs-toggle="tooltip" data-bs-placement="top" title="Edit Image"/>
          </button> : null}
        </div>
          <div style={{visibility: "hidden", display: "none"}}>
              <input ref={fileRef} id="upload" type="file" onChange={doUpload}/>
          </div>
      </div>

  )
}

export default SecAvatar
